<div class="container">
    <div class="vertical-line"></div>
    <div class="form-container">
      <div class="change-password-container">
        <form (ngSubmit)="onSubmit(passwordForm)" #passwordForm="ngForm">
          <mat-form-field appearance="outline">
            <mat-label>Current Password</mat-label>
            <input matInput
            [type]="showPassword ? 'text' : 'password'"
            required name="currentPassword" [(ngModel)]="currentPassword" />
            <i
            class="eye-icon"
            (click)="togglePasswordVisibility()"
            [ngClass]="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'">
          </i>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>New Password</mat-label>
            <input matInput 
            [type]="showPassword ? 'text' : 'password'"
            required 
            name="newPassword" [(ngModel)]="newPassword" />
            <i
            class="eye-icon"
            (click)="togglePasswordVisibility()"
            [ngClass]="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'">
          </i>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Confirm New Password</mat-label>
            <input matInput 
            [type]="showPassword ? 'text' : 'password'"
             required name="confirmNewPassword" [(ngModel)]="confirmNewPassword" />
             <i
            class="eye-icon"
            (click)="togglePasswordVisibility()"
            [ngClass]="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'">
          </i>
          </mat-form-field>
          <button mat-raised-button color="primary" type="submit" [disabled]="passwordForm.invalid">Change Password</button>
        </form>
        <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
        <div *ngIf="message" [ngClass]="{ success: isSuccess, error: !isSuccess }">
        <!-- {{ message }}--> 
        </div>
      </div>
    </div>
  </div>
  